import { useAppContext } from 'src/context/store/app-provider';

export const useCollectWidgetContext = () => {
  const { experiments, aid, entityId, offers } = useAppContext();

  return { experiments: { experiments, entityId }, aid, entityId, offers };
};
